import React from 'react';
import './SecurityCta.css';

function SecurityCta() {
  return (
    <section className="security-cta-wrapper">
      <div className="security-cta-container">
        <div className="security-cta-image-container">
          <img 
            src="https://sendbird.imgix.net/cms/cta.png" 
            alt="Enterprise-grade security" 
          />
        </div>
        <div className="security-cta-content-container">
          <h3 className="security-cta-title">Enterprise-grade security, fully transparent.</h3>
          <p className="security-cta-description">
            Sendbird operates a trust center where you can find all our compliance certifications & attestations, penetration test reports, FAQ’s, policies and more
          </p>
          <a 
            role="link" 
            href="" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="security-cta-link"
          >
            Visit our trust center
          </a>
        </div>
      </div>
    </section>
  );
}

export default SecurityCta;